<script setup lang="ts">
import 'devextreme/dist/css/dx.light.css';

import { ref, onMounted } from 'vue';
import deMessages from 'devextreme/localization/messages/de.json';
import { loadMessages, locale } from 'devextreme/localization';
loadMessages(deMessages);
locale('de');
const dataauth = useAuth();

if (typeof window !== 'undefined') {
    //  localStorage.setItem('NL_ID', '1');
}
const { data, error } = await useFetch('/api/login');

if (error.value) {
    console.error('Login failed:', error.value);
} else {
    const token = data.value.token;
    sessionStorage.setItem('temp_tok_laravel', token);
    //    console.log('Laravel token:', token);
}
onMounted(() => {
 
    const useremail = dataauth.data.value?.user?.email;
    const emailstr = dataauth.data.value?.userDetail?.userPrincipalName;
    localStorage.setItem('user-email', useremail.toLowerCase());
    var str = emailstr.toLowerCase();
    const parts = str.split('@');
    localStorage.setItem('windows_name', parts[0]);
});
</script>

<template>
    <div>
        <NuxtLayout>
            <NuxtPage />
        </NuxtLayout>
    </div>
</template>
